/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.blockModule').service('BulbBlockViewSwitcherService', [
  '$cookies',
  '$timeout',
  'Foundation',
  'Restangular',
  'BulbAuthService',
  'BulbErrorService',
  BulbBlockViewSwitcherService,
]);

function BulbBlockViewSwitcherService(
  $cookies,
  $timeout,
  Foundation,
  Restangular,
  BulbAuthService,
  BulbErrorService,
) {

  this.isAnonymous = !BulbAuthService.currentUser.isAuthenticated();
  this.unitTypeToOpenInNewTab = '';

  this.prefs = {
    useTileViewProfile: true,
    useTileViewCollection: true,
    useTileViewGroupMember: true,
    useTileViewGroupContent: true,
    useTileViewGroupAssignment: true,
    useTileViewAssetLibrary: false,
  };

  this.getViewSettingKey = function getViewSettingKey(infoType) {

    let tmp = 'useTileView';
    switch (infoType) {
      case 'profile':
        tmp += 'Profile';
        break;
      case 'collection':
        tmp += 'Collection';
        break;
      case 'group_member':
        tmp += 'GroupMember';
        break;
      case 'group_content':
        tmp += 'GroupContent';
        break;
      case 'group_assignment':
        tmp += 'GroupAssignment';
        break;
      case 'asset_library':
        tmp += 'AssetLibrary';
        break;
    }
    return tmp;
  };

  // Initialize tile/list view preferences
  if (this.isAnonymous) {
    // get values from cookie
    const tmp = $cookies.get('prefs');
    if (tmp) {
      $.extend(this.prefs, $.parseJSON(tmp));
    }
  } else {
    $.extend(this.prefs, BulbAuthService.currentUser.prefs);
  }

  this.isSwitchable = function isSwitchable(infoType) {
    /* jshint camelcase: false */
    return Foundation.utils.is_large_up() || (infoType === 'asset_library' && Foundation.utils.is_medium_up());
  };

  this.isTile = function isTile(infoType) {
    if (infoType === 'assignment') {
      return true;
    }
    if (this.isSwitchable(infoType)) {
      return this.prefs[this.getViewSettingKey(infoType)];
    }
    return false;
  };

  this.updateAccountPreferences = function updateAccountPreferences(infoType, val) {

    if (!this.isSwitchable(infoType)) {
      return;
    }

    this.prefs[this.getViewSettingKey(infoType)] = val;

    // always update cookie
    const expire = new Date();
    expire.setFullYear(expire.getFullYear() + 10);
    $cookies.put('prefs', JSON.stringify(this.prefs), { expires: expire, secure: true, samesite: 'None' });

    if (!this.isAnonymous) {
      angular.copy(this.prefs, BulbAuthService.currentUser.prefs);

      Restangular.one('accounts', BulbAuthService.currentUser.id)
        .patch({ prefs: this.prefs }).catch((error) => {
          BulbErrorService.error('Cannot update the user preferences', error);
        });
    }
  };

  /**
   * Function that disables the dragging feature for the 'My Archive Collection',
   * and also manages tab and focus
   * @param userView
   * The flag that describes user view.
   */
  this.disableDraggingForArchiveCollection = function disableDraggingForArchiveCollection(userView) {
    // DOM isn't completely loaded at this point
    // We disable the dragging capability for the archive collection.
    $timeout(() => {
      const $myArchiveCollection = jQuery('.bulb-block-archive-collection');
      if ($myArchiveCollection) {
        $myArchiveCollection.draggable('option', 'disabled', true);
      }

      if (userView === 'tile') {
        $('.bulb-block-switch-view-btn-list').focus();
      } else if (userView === 'list') {
        $('.bulb-block-switch-view-btn-tile').focus();
      }
    });
  };

}
